import styled from 'styled-components';
import { Card } from 'antd';

export const AnalyticsCardWrapper = styled(Card)`
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#292929' : '#ffffff';
    }} !important;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.colors.border.default} !important;
    box-shadow: none !important;
    min-height: 0;
    transition: box-shadow 0.2s ease;
    margin: 0;
    display: flex;
    flex-direction: column;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    cursor: default;

    * {
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        cursor: default;
    }

    &:hover {
        box-shadow: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'none' : '0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)';
    }};
    }

    @media (max-width: 768px) {
        border-radius: 14px;
    }

    @media (max-width: 480px) {
        border-radius: 12px;
    }

    .ant-card-body {
        padding: 14px;
        min-height: 0;
        display: flex;
        flex-direction: column;

        @media (max-width: 768px) {
            padding: 12px;
        }

        @media (max-width: 480px) {
            padding: 10px;
        }
    }
`;

export const AnalyticsCardContent = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    gap: 0;
    padding: 0;
`;

export const AnalyticsCardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-bottom: 8px;
`;

export const AnalyticsCardIcon = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)';
    }};
    color: ${({ theme }) => theme.colors.text.primary};
`;

export const AnalyticsCardTitle = styled.div`
    font-size: 13px;
    line-height: 1.3;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#8A98A7' : '#666666';
    }};
    font-weight: 500;
    font-family: var(--font-family-figtree);

    @media (max-width: 768px) {
        font-size: 12px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
    }
`;

export const AnalyticsCardValue = styled.div`
    font-size: 28px;
    line-height: 1.2;
    font-weight: 700;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
    font-family: var(--font-family-lufga);
    letter-spacing: -0.5px;

    @media (max-width: 1024px) {
        font-size: 26px;
    }

    @media (max-width: 768px) {
        font-size: 24px;
        letter-spacing: -0.3px;
    }

    @media (max-width: 480px) {
        font-size: 22px;
        letter-spacing: 0;
    }
`;

// KPI Card Styles - Simple card matching the image design
export const KPICardWrapper = styled(Card)`
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#292929' : '#ffffff';
    }} !important;
    border-radius: 16px;
    border: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '1px solid #2C2C2C' : '1px solid #E5E5E5';
    }} !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    margin: 0;
    height: 100%;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    cursor: default;

    * {
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        cursor: default;
    }

    &:hover {
        box-shadow: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '0 4px 12px rgba(0, 0, 0, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.12)';
    }};
        transform: translateY(-2px);
    }

    .ant-card-body {
        padding: 16px 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 12px;
        height: 100%;
        user-select: none;
        cursor: default;

        @media (max-width: 768px) {
            padding: 14px 20px;
        }

        @media (max-width: 480px) {
            padding: 12px 16px;
        }
    }

    * {
        user-select: none;
        cursor: default;
    }
`;

export const KPICardTitle = styled.div`
    font-size: 16px;
    line-height: 1.5;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#8A98A7' : '#666666';
    }};
    font-weight: 500;
    font-family: var(--font-family-figtree);
    margin: 0;
    padding: 0;

    @media (max-width: 768px) {
        font-size: 14px;
    }

    @media (max-width: 480px) {
        font-size: 13px;
    }
`;

export const KPICardContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 0;
    gap: 10px;
    width: 100%;
    max-width: 100%;
    min-width: 0;

    @media (max-width: 768px) {
        gap: 8px;
    }

    @media (max-width: 480px) {
        gap: 6px;
    }
`;

export const KPICardValue = styled.div`
    font-size: 44px;
    line-height: 1.2;
    font-weight: 700;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
    font-family: var(--font-family-lufga);
    letter-spacing: -0.5px;
    margin: 0;

    @media (max-width: 1024px) {
        font-size: 38px;
    }

    @media (max-width: 768px) {
        font-size: 32px;
        letter-spacing: -0.3px;
    }

    @media (max-width: 480px) {
        font-size: 28px;
        letter-spacing: 0;
    }
`;

export const KPICardChangeRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 0;

    @media (max-width: 768px) {
        gap: 10px;
    }

    @media (max-width: 480px) {
        gap: 8px;
    }
`;

export const KPICardChangeText = styled.span`
    font-size: 13px;
    line-height: 1.5;
    color: #747474;
    font-weight: 500;
    font-family: var(--font-family-figtree);

    @media (max-width: 768px) {
        font-size: 12px;
    }

    @media (max-width: 480px) {
        font-size: 11px;
    }
`;

export const KPICardChangeBadge = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 10px;
    border-radius: 40px;
    font-size: 10px;
    font-weight: 600;
    font-family: var(--font-family-figtree);
    background-color: ${({ $positive }) => $positive ? '#D9F8E6' : '#FCDFE1'};
    color: ${({ $positive }) => $positive ? '#007838' : '#F42519'};
    flex-shrink: 0;
    white-space: nowrap;

    .anticon {
        font-size: 10px;
        color: ${({ $positive }) => $positive ? '#007838' : '#F42519'};
        display: flex;
        align-items: center;
    }

    @media (max-width: 768px) {
        padding: 5px 8px;
        font-size: 9px;

        .anticon {
            font-size: 9px;
        }
    }

    @media (max-width: 480px) {
        padding: 4px 6px;
        font-size: 8px;
        gap: 3px;

        .anticon {
            font-size: 8px;
        }
    }
`;

